import { render, staticRenderFns } from "./KitsPanel.vue?vue&type=template&id=08ba2b75&"
import script from "./KitsPanel.vue?vue&type=script&lang=js&"
export * from "./KitsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports